<template>
  <div class="row">
    <div class="flex justify-center relative text-center mb-20">
        <div class="absolute left-0 top-4 flex items-center justify-center text-blue text-2xl cursor-pointer" @click="clickedBack">
          <fai :icon="['fal', 'chevron-left']" />
          <p class="ml-2 mb-0">back</p>
        </div>
        <p class="mb-3 text-blue text-6xl font-black font-['AileronThin']">$pringpay</p>
    </div>

    <div class="large-12 columns">
      <div class="row center-button bottom-spacing">
        <button @click="clickedSpence" class="button font-bold tracking-wide text-2xl pl-4">
          connect to spence
          <img class="h-7 pl-2" :src="spenceIcon" alt="spence"/>
        </button>
      </div>
      <div class="row center-button">
        <button @click="clickedMerrco" class="button font-bold tracking-wide text-2xl pl-4">
          connect to merrco
          <img class="h-6 pl-2" :src="merrcoIcon" alt="merrco"/>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import merrcoIcon from 'merrco/merrco_icon.svg';
import spenceIcon from 'spence/spence_icon.svg';

export default {
  name: "SpringpayLanding",
  data() {
    return {
      merrcoIcon,
      spenceIcon
    }
  },
  computed: {
    merchantId() {
      return this.$route.params.id
    }
  },
  methods: {
    clickedSpence() {
      this.$router.push(`/merchants/${this.merchantId}/spence_landing`)
    },
    clickedMerrco() {
      this.$router.push(`/merchants/${this.merchantId}/merrco_landing`)
    },
    clickedBack() {
      location.replace(`/merchants/${this.merchantId}`)
    }
  }
}
</script>
